import { render, staticRenderFns } from "./UsersSinglePermissions.vue?vue&type=template&id=01f5b420&"
import script from "./UsersSinglePermissions.vue?vue&type=script&lang=js&"
export * from "./UsersSinglePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports